import { M } from '../tokens/colors.js';
/**
 * Portal Manta · NORMAS_ABNT_NBR
 * Extraído de App.jsx v29.3 (via AST)
 */
const NORMAS_ABNT_NBR = {
  // Concreto/estruturas
  '6118':'Projeto de estruturas de concreto', '7480':'Aço para armaduras de concreto armado',
  '8800':'Projeto de estruturas de aço e mistas', '14931':'Execução de estruturas de concreto',
  '15200':'Estruturas de concreto em situação de incêndio', '6122':'Projeto e execução de fundações',
  // Geotecnia/sondagem
  '6484':'Sondagens SPT', '11682':'Estabilidade de encostas',
  '6457':'Amostras de solo - Preparação para ensaios', '7182':'Solo - Ensaio de compactação',
  // Pavimentação
  '7207':'Terminologia e classificação de pavimentação', '15573':'Bases estabilizadas granulometricamente',
  '15645':'Execução de obras de pavimentação',
  // OAE/pontes
  '7187':'Projeto de pontes de concreto armado e protendido', '6123':'Forças devidas ao vento',
  '7188':'Carga móvel rodoviária e de pedestres em pontes',
  // Materiais/ensaios
  '5738':'Concreto - Moldagem e cura de corpos-de-prova', '5739':'Concreto - Ensaio de compressão',
  '8522':'Concreto endurecido - Módulos estáticos de elasticidade',
  // Sinalização/segurança/acessibilidade
  '14723':'Acessibilidade - Mobiliário urbano', '15486':'Dispositivos de contenção viária',
  '9050':'Acessibilidade a edificações',
  // Topografia/desenho
  '13133':'Execução de levantamento topográfico', '10068':'Folha de desenho - Layout',
  '10582':'Apresentação da folha para desenho', '13142':'Dobramento de cópia',
  '8403':'Aplicação de linhas em desenhos',
  // Geral construção
  '15575':'Edificações habitacionais - Desempenho', '5410':'Instalações elétricas BT',
  '5419':'Proteção contra descargas atmosféricas',
};

export { NORMAS_ABNT_NBR };
export default NORMAS_ABNT_NBR;
